import { Component, createEffect, createSignal } from 'solid-js'
import { useNavigate, useParams } from '@solidjs/router'
import { userStore } from '/web/store'
import { usersApi } from '/web/store/data/user'

import { isLoggedIn } from '/web/store/api'

const ResetPassword: Component = () => {
  const params = useParams()
  const nav = useNavigate()
  const [error, setError] = createSignal('')
  const [success, setSuccess] = createSignal(false)
  const [loading, setLoading] = createSignal(false)

  createEffect(() => {
    if (isLoggedIn()) {
      nav('/')
    }
  })

  const handleSubmit = async (e: SubmitEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    const form = e.target as HTMLFormElement
    const password = form.password.value
    const confirm = form.confirm.value

    if (password !== confirm) {
      setError('Passwords do not match')
      setLoading(false)
      return
    }

    const token = params.token
    try {
      const res = await usersApi.resetPassword(token, password)
      if (res.error) {
        setError(res.error)
        setLoading(false)
        return
      }

      setSuccess(true)
      setTimeout(() => {
        nav('/')
        setTimeout(() => {
          userStore.loginModal(true)
        }, 1000)
      }, 3000)
    } catch (err: any) {
      setError(err.message || 'Failed to reset password')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div class="from-bg-800 to-bg-900 flex min-h-screen items-center justify-center bg-gradient-to-b">
        <div class="bg-bg-800 m-4 w-full max-w-md rounded-lg border border-white/10 p-8 shadow-xl">
          <h2 class="mb-6 text-center text-2xl font-bold text-white">Reset Password</h2>

          {success() ? (
            <div class="text-center text-green-500">
              Password successfully reset! Redirecting to login...
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {error() && (
                <div class="mb-4 rounded bg-red-500/10 p-3 text-center text-red-500">{error()}</div>
              )}

              <div class="mb-4">
                <label class="mb-2 block text-sm text-white" for="password">
                  New Password
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  required
                  minLength={8}
                  class="w-full rounded-lg border border-white/10 bg-white/5 p-2.5 text-white"
                  placeholder="Enter new password"
                />
              </div>

              <div class="mb-6">
                <label class="mb-2 block text-sm text-white" for="confirm">
                  Confirm Password
                </label>
                <input
                  id="confirm"
                  name="confirm"
                  type="password"
                  required
                  class="w-full rounded-lg border border-white/10 bg-white/5 p-2.5 text-white"
                  placeholder="Confirm new password"
                />
              </div>

              <button
                type="submit"
                disabled={loading()}
                class="w-full rounded-lg bg-gradient-to-r from-cosplay-blue-200 to-cosplay-purple p-2.5 text-white disabled:opacity-50"
              >
                {loading() ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>
          )}
        </div>
      </div>
    </>
  )
}

export default ResetPassword
